import axios from "axios";
import React, { useEffect, useState } from "react";

const FacilitiesC = () => {

    const [facilities,setFacilities] = useState([]);

    useEffect(() =>{
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_FACILITIES;
        axios.get(`${apiBaseUrl}${Url}`)
        .then(response => setFacilities(response.data))
        .catch(error => console.error("Error fetching API",error));
    },[]);

    return (
        <div className="row">
        {facilities.map(facility => 
            <div className="col-md-6 col-lg-4 mb-4 mb-lg-0 my-2"  key={facility.id}>
                <div className="card card-special">
                  <div className="media align-items-center mb-1">
                    <span className="card-special__icon">
                        <i className={facility.icon}></i>
                    </span>
                    <div className="media-body">
                      <h4 className="card-special__title">{facility.title}</h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <p align="justify">{facility.description}</p>
                  </div>
                </div>
        </div>
        )} 
                      
            
                    </div>
        
        
    );
}

export default FacilitiesC;